import { createAsyncThunk } from "@reduxjs/toolkit";
import { DEALER_DETAILS } from "../../constants/dealerApiConstants";
import { postApi } from "../../../services/apiServices";
import Alertify from "../../../services/alertify";

// /*----------------Dealer Codes ---------------- */
// export const DealerCodes = createAsyncThunk(
//   "dealer-codes/admin",
//   async (reqData) => {
//     try {
//       const response = await getApi(DEALER_CODES, reqData);
//       return response;
//     } catch (error) {
//       console.log("Error Dealer Codes API", error);
//       Alertify.error(error.message);
//       return Promise.reject(error);
//     }
//   }
// );
/*----------------Dealer Details ---------------- */
export const UserDealerDetails = createAsyncThunk(
  "dealer-details/user",
  async (reqData) => {
    try {
      const response = await postApi(DEALER_DETAILS, reqData);
      return response;
    } catch (error) {
      console.log("Error Dealer Details API:", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);
